module.exports = __webpack_public_path__ + "static/media/icon-witsoccer.856d3e66.png";